import { createSelector } from "@reduxjs/toolkit";
import compact from "lodash/compact";
import find from "lodash/find";
import { getPropertyValue } from "utils/misc/css-util";

export const ModelPortfolioSelector = {
  state: (state) => state.ultrahigh.modelPortfolio,
  unitholders: (state) => ModelPortfolioSelector.state(state).unitholders,
  strategyList: (state) => ModelPortfolioSelector.state(state).strategyList,
  fetchingStrategy: (state) => ModelPortfolioSelector.state(state).fetchingStrategy,
  fetchingUnitHolder: (state) => ModelPortfolioSelector.state(state).fetchingUnitHolder,
  filterUnitholder: (state) => ModelPortfolioSelector.state(state).filterUnitholder,
  modelPortDocument: (state) => ModelPortfolioSelector.state(state).modelPortDocument,
  strategy: (state) => ModelPortfolioSelector.state(state).strategy,
  // strategyAssets: state => ModelPortfolioSelector.strategy(state).assets,
  strategyCriteries: (state) => ModelPortfolioSelector.strategy(state).criteries,
  strategyData: (state) => {
    const strategies = ModelPortfolioSelector.strategyList(state);
    const activeStrategy = ModelPortfolioSelector.strategy(state).activeStrategy;
    if (!strategies || !activeStrategy) {
      return {};
    }
    return find(strategies, { allocStrategyName: activeStrategy }) || {};
  },

  mutualFundAssetChart: createSelector([(state) => ModelPortfolioSelector.strategyData(state)], (strategyData) => {
    const sortData = [...(strategyData.fundTypeList ?? [])].sort((a, b) => a.ktbMfTypeCode - b.ktbMfTypeCode);

    return compact(
      sortData?.map((data) => {
        if (data?.recommendRatio > 0) {
          return {
            label: data.ktbMfTypeNameTh,
            value: data.recommendAmt > 0 ? data.recommendAmt : data.recommendRatio,
            percentage: data.recommendRatio,
            backgroundColor: getPropertyValue({ varName: `--chart-color-${+data.ktbMfTypeCode}` }),
            borderColor: getPropertyValue({ varName: `--chart-color-${+data.ktbMfTypeCode}` }),
            className: `text-white chart-${data.ktbMfTypeCode}`,
          };
        }
        return null;
      })
    );
  }),
};
